export const CURRENT_APPOINTMENT_HEADER = "sha-position-appointment-id";
export const POSITION_APPOINTMENT_URL_REGEX = /^\/app-([^\/]+)(\/*.*)/;
export const POSITION_APPOINTMENT_PREFIX = "app-";

type PathWithPositionAppointment = {
    appId: string;
    remainingPath: string;
};

/**
 * Removes the specified prefix from the given string if it exists.
 *
 * @param {string} s - The string to remove the prefix from.
 * @param {string} w - The prefix to remove.
 * @return {string} The modified string after removing the prefix.
 */
export const trimPrefix = (s: string, w: string) => {
    return s && s.startsWith(w)
        ? s.slice(w.length)
        : s;
};

/**
 * Extracts the app id and remaining path from the given path.
 * @param path 
 * @returns object with app id and remaining path or undefined if app id not found
 */
export const extractPathAndPosition = (path: string): PathWithPositionAppointment | undefined => {
    const match = path.match(POSITION_APPOINTMENT_URL_REGEX);
    if (match) {
        const [, appId, remainingPath] = match;
        return { appId, remainingPath: trimPrefix(remainingPath, '/') };
    } else
        return undefined;
};

/**
 * Get path without app id
 * @param path path to get app id from
 * @returns 
 */
export const getPathWithoutAppId = (path: string): string => {
    const match = path.match(POSITION_APPOINTMENT_URL_REGEX);
    if (match) {
        const [, /*appId*/, remainingPath] = match;
        return trimPrefix(remainingPath, '/');
    } else
        return trimPrefix(path, '/');
};

/**
 * Replaces the app id in the path
 * @param path path to replace app id in
 * @param appId new app id
 * @returns 
 */
export const replaceAppIdInPath = (path: string, appId: string): string => {
    const remainingPath = getPathWithoutAppId(path);

    return `/${POSITION_APPOINTMENT_PREFIX}${appId}/${remainingPath}`;
};

export const urlContainsAppId = (url: string): boolean => POSITION_APPOINTMENT_URL_REGEX.test(url);